import { type Sort } from '@angular/material/sort';

import { compareValues } from '../utils/comparator';
import { type StrictOmit } from '../utils/public-api';

/** Sort options for a list of items. */
export type SortOptions<T> = StrictOmit<Sort, 'active'> & {

  /** Field by which items should be sorted. */
  readonly active: T;
};

export namespace SortOptions {

  /**
   * Sort with options.
   * @param items Items.
   * @param options Sort options.
   */
  export function sort<T>(items: T[], options: SortOptions<keyof T>): T[] {
    return [...items].sort((first, second) => {
      const compareResult = compareValues(first[options.active], second[options.active]);
      return options.direction === 'asc' ? compareResult : -compareResult;
    });
  }

  /**
   * Type guard to check if sort state is valid SortOptions.
   * @param sortState Sort state to validate.
   * @param sortFields Sort fields.
   */
  export function isSortOptions<T extends string>(sortState: Sort, sortFields: Record<string, T>): sortState is SortOptions<T> {
    return sortState.active in sortFields;
  }
}
